import React from 'react';
import { GameCard, GameCardProps } from 'components/GameCard/GameCard';

import styles from './Play.module.scss';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import { routes } from 'routing/routes';

import tsPoster from '../../assets/img/play-to-mint/ts-poster-small.jpg';
import tsPosterMobile from '../../assets/img/play-to-mint/ts-poster-small-mobile.jpg';
import bbPoster from '../../assets/img/play-to-mint/bb-poster-small.jpg';
import bbPosterMobile from '../../assets/img/play-to-mint/bb-poster-small-mobile.jpg';

import mobile from '../../assets/img/egg/play-to-mint/mobile.jpg';
import desktop from '../../assets/img/egg/play-to-mint/desktop.jpg';
import { Egg } from 'components/Egg/Egg';

const games: GameCardProps[] = [
  {
    poster: tsPoster,
    mobilePoster: tsPosterMobile,
    title: 'Twilight Shift',
    description:
      'Incoming message from the Shadow District: DuskBreakers are defying DuskTech and sneaking into a dangerous section of the Dusk during their off hours to secure precious materials. They’re using these materials for some nefarious… and adorable purposes back in the Shadow District. \n\nAre you stealthy enough to join their mission?',
    playLink: routes.launcher(),
    macos: false,
  },
  {
    poster: bbPoster,
    mobilePoster: bbPosterMobile,
    title: 'Beast Battler',
    description:
      'Dusktech is requiring all DuskBreaker recruits to practice their blasting skills by playing the Beast Battler Simulation! In this simulation, you will face some of the real life terrors that live on the Dusk. The techniques you learn in this simulation will help you do your future job on board the real ship. \n\nHappy blasting!',
    playLink: routes.game(),
    macos: true,
  },
];

type PlayToMintBannerProps = {
  style?: React.CSSProperties;
};

const PlayToMintBanner = ({ style }: PlayToMintBannerProps) => {
  return (
    <div className={styles.playToMintBanner} style={style}>
      <div className={styles.bannerImage}>
        <LazyLoadImage className={styles.mobileImg} src={mobile} />
        <LazyLoadImage className={styles.desktopImg} src={desktop} />
      </div>
      <div className={styles.bannerContent}>
        <div>
          <h3 className="subheading-large">Play To Mint</h3>
          <p className="body-large text-60">
            By playing a round of our games, you can earn an allow list spot. This will let you mint
            up to three Gribble eggs
          </p>
        </div>
        <Link to={routes.playToMint()} className={styles.learnMore}>
          <button className="btn btn-sm btn-primary">Learn more</button>
        </Link>
      </div>
    </div>
  );
};

export const Play = () => {
  const GAME_CARD_MAX_WIDTH = 646;
  const GAME_CARDS_GAP = 20;

  const playToMintMaxWidth =
    GAME_CARD_MAX_WIDTH * games.length + GAME_CARDS_GAP * (games.length - 1);

  return (
    <Egg>
      <div className={styles.container}>
        <h1 className="heading-default">Enter the Dusk</h1>
        <p className="body-large text-60">
          Immerse yourself in the DuskBreakers universe by playing our games
        </p>

        <div className={styles.games}>
          {games.map((game) => {
            return <GameCard className={styles.gameCard} key={game.title} {...game} />;
          })}
        </div>
        <PlayToMintBanner style={{ maxWidth: `${playToMintMaxWidth}px` }} />
      </div>
    </Egg>
  );
};
